<template lang="html">
    <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <span class="headline">Void Payment Confirmation</span>
            </v-card-title>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout>
                      <v-flex xs12>
                        <p><b>Total:</b> {{paymentInfo.Total}}</p>
                        <p><b>Last4:</b> {{paymentInfo.Last4}}</p>
                        <p><b>Trans Ref:</b> {{paymentInfo.TransRef}}</p>
                        <p><b>Type:</b> {{paymentInfo.Type}}</p>
                        <p><b>Will Impact These Participants:</b></p>
                        <ul>
                          <li v-for="part in paymentInfo.Participants">{{part.ParticipantName}}</li>
                        </ul>
                      </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="closeDialog">Close</v-btn>
                <v-btn  color="red darken-1" flat  @click="voidPayment(paymentInfo.id)">Void</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>


</template>

<script lang="js">
    export default  {
        name: 'void-payment',
        props: ["payment", "dialog"],
        components: {
          },
        mounted() {

        },
        data() {
            return {
                working: false,
              paymentInfo: {}
            }
        },
        methods: {
          voidPayment(paymentID) {
            let vueThis = this
            this.closeDialog()
            this.$services.payments.patch(paymentID,
                {
                  'Status': 'Voided',
                  'StatusNote' : 'Voided by GTP',
                  'StatusNoteDate': Date.now()
                }).then((result) => {
                  console.log('void patch result', result)
              vueThis.$updatePaymentStatus(result)
              vueThis.$emit("alertUser", "success", "Payment Voided!!")

            }).catch(function (error) {
              console.error('update Error!', error);
              vueThis.$emit("alertUser", "error", "There was an error processing your request")

            });
          },
            closeDialog() {
                this.$emit("closeDialog", "paymentVoid")
            },
        },
      watch: {
        payment: function (val) {
          if (val != null) {
            this.paymentInfo = this.$structuredData.payments.find((x)=>x.id == this.payment)
          }
        }
      }
    }
</script>

<style scoped lang="scss">

</style>
